import { motion } from "framer-motion";

export const OVERLAY_MOTION = {
  initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 },
};
export const PANEL_MOTION = {
  initial: { opacity: 0, y: 30, scale: 0.98 },
  animate: { opacity: 1, y: 0, scale: 1 },
  exit: { opacity: 0, y: 20, scale: 0.98 },
  transition: { duration: 0.35, ease: [0.22, 1, 0.36, 1] },
};
const STEP_MOTION = {
  initial: { opacity: 0, x: 16 }, animate: { opacity: 1, x: 0 }, exit: { opacity: 0, x: -16 },
  transition: { duration: 0.25 },
};

export const StepShell = ({ children }) => <motion.div {...STEP_MOTION}>{children}</motion.div>;